import {call, put, fork} from 'redux-saga/effects';

import axios from 'axios';
// import * as lexActionType from '../actionsType/lexGenCopyLinkCopy.actionType';
import * as lexActionType from '../actionsType/lexCertEnrollAvailCredit.actionType';
import {getBaseUrl} from '../../../core/utility/filter.utility';

function fetchEnrollAvailCredit(reqObj) {
    return axios({
        method: 'post',
        url: `${getBaseUrl()}/rest/credit/availableCreditNumber`,
        data: reqObj
    });
    // return axios.get('static/data/availableCreditNumber.json');
}

function fetchEnrollmentCodeStatus(reqObj) {
    return axios({
        method: 'post',
        url: `${getBaseUrl()}/rest/credit/checkCertEnrollCodeStatus`,
        data: reqObj
    });
    // return axios.get('static/data/enrollCode.json');
}

function fetchrequestCredits(reqObj) {
    return axios({
        method: 'post',
        url: `${getBaseUrl()}/rest/credit/requestCredits`,
        data: reqObj
    });
    // return axios.get('static/data/requestCredits.json');
}

function sync3DEdu() {
    const params = new URLSearchParams(window.location.search);
    const aTy = params.get('aTy');
    if (aTy && aTy === '1') {
        try {
            const cId = params.get('lpId');
            const cType = params.get('lexType');

            // pUrl is of this shape https://devopslkd2ypmh28171552-euw1-28dsw10122.iam.3dx-staging.3ds.com:443/
            const xdeduUrlStr = params.get('pURL').replace('.iam', '-3dedu');
            const xdeduUrl = new URL(xdeduUrlStr);
            const xdlearnSyncUrl = `${xdeduUrl.origin}/3dedu/RetrieveData`;

            return axios.post(xdlearnSyncUrl,
                {
                    service: 'contentSyncInfo',
                    aTy: '1',
                    cId: cId,
                    cType: cType,
                    uuid: ''
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    withCredentials: true
                }
            );
        } catch (error) {
            console.error('Error in synch3DEdu:', error);
            return Promise.reject(error); // Re-throw the error
        }
    }
    return Promise.resolve('not 3DEdu');
}


function fetchCancelCredit(reqObj) {
    return axios({
        method: 'post',
        url: `${getBaseUrl()}/rest/credit/releaseCredits`,
        data: reqObj
    });
    // return axios.get('static/data/releaseCredits.json');
}

export function* lexCertEnrollAvailCreditSaga(request) {
    try {
        const response = yield call(fetchEnrollAvailCredit, request.payload);
        const content = response.data;
        yield put({
            type: lexActionType.AVAILCRDIT_SUCCESS,
            payload: content
        });
    } catch (error) {
        yield put({
            type: lexActionType.AVAILCRDIT_ERROR,
            payload: 'There has been some issue with 3DS Learning Space. Please try after sometime.'
        });
    }
}

export function* lexCertRequestCreditsSaga(request) {
    try {
        const response = yield call(fetchrequestCredits, request.payload);
        // sync credits on 3DEdu after successful request of credits
        yield fork(sync3DEdu);
        const content = response.data;
        yield put({
            type: lexActionType.REQ_CREDIT_SUCCESS,
            payload: content
        });
    } catch (error) {
        yield put({
            type: lexActionType.REQ_CREDIT_ERROR,
            error: error
        });
    }
}

export function* lexEnrollmentCodeValidation(request) {
    try {
        const response = yield call(fetchEnrollmentCodeStatus, request.payload);
        const responseData = response.data;
        yield put({
            type: lexActionType.ENROLLMENT_CODE_SUCCESS,
            payload: responseData
        });
    } catch (error) {
        yield put({
            type: lexActionType.ENROLLMENT_CODE_ERROR,
            error: error
        });
    }
}

export function* lexCertCancelEnrollSaga(request) {
    try {
        const response = yield call(fetchCancelCredit, request.payload);
        const content = response.data;
        yield put({
            type: lexActionType.CANCEL_ENROLL_SUCCESS,
            payload: content
        });
    } catch (error) {
        yield put({
            type: lexActionType.CANCEL_ENROLL_ERROR,
            error: error
        });
    }
}
